import React, {memo} from 'react'

import SettingsBlock from '../../../../SettingsBlock/SettingsBlock'

import {filesPublicationPlaceholder} from './JobFilesPublication.consts'
import useJobFilesPublication from './JobFilesPublication.hooks'
import type {JobFilesPublicationProps} from './JobFilesPublication.types'

import styles from './JobFilesPublication.css'

import Input, {Size} from 'src/components/pages/PipelinesPages/components/common/Input'

function JobFilesPublication({jobId}: JobFilesPublicationProps) {
  const {handlerFilesPublicationTextAreaChange, filesPublication} = useJobFilesPublication(jobId)

  return (
    <SettingsBlock
      id="files"
      collapsible
      collapsedDefault={false}
      title="Publish Files"
      collapsedNote={filesPublication.replace(/\n/g, ', ')}
      details={
        'The list of newline-delimited relative paths to files and/or directories shared with subsequent Jobs.'
      }
    >
      <div className={styles.textAreaWrapper}>
        <Input
          spellCheck={false}
          autoComplete="off"
          onChange={handlerFilesPublicationTextAreaChange}
          inputClassName={styles.textArea}
          size={Size.FULL}
          placeholder={filesPublicationPlaceholder}
          multiline
          value={filesPublication}
          aria-label={'Publish Files'}
        />
        <div className={styles.notice}>
          {'Use the * wildcard to include all files in the current directory.'}
        </div>
      </div>
    </SettingsBlock>
  )
}

export default memo(JobFilesPublication)
